import { IconStatusAndColor } from './common';

// eslint-disable-next-line import/prefer-default-export
export const InsuranceStatus = {
  WARNING: 'WARNING',
  ERROR: 'ERROR',
  ACTIVE: 'ACTIVE'
};

export const InsuranceActions = {
  EDIT: 'EDIT',
  DELETE: 'DELETE',
  VIEW_POLICY: 'VIEW_POLICY'
};

export const getInsuranceStatus = (insurance, t) => {
  const { status, message } = insurance;
  const getInsuranceDescription = messageList => {
    let description = '';
    if (messageList.length > 1) {
      messageList.forEach(msg => {
        description += `• ${t(`INSURANCES_VIEW.MESSAGE.${msg}`)}. \n `;
      });
    } else {
      description = t(`INSURANCES_VIEW.MESSAGE.${messageList[0]}`);
    }
    return description;
  };

  switch (status) {
    case InsuranceStatus.ERROR:
      return {
        description: getInsuranceDescription(message),
        type: IconStatusAndColor.ERROR.status
      };
    case InsuranceStatus.ACTIVE:
      return {
        description: t('INSURANCES_VIEW.MESSAGE.ACTIVE'),
        type: IconStatusAndColor.OK.status
      };
    default:
      return {
        description: t('COMMON.NO_INFORMATION'),
        type: IconStatusAndColor.NONE.status
      };
  }
};

export const createInsurerNameList = insurers => {
  return insurers
    ? insurers?.map(insurer => {
        return {
          key: insurer.id,
          name: insurer.name
        };
      })
    : [];
};

export const createAgencyNameList = agencies => {
  return agencies
    ? agencies.map(agency => {
        return {
          key: agency.id,
          name: agency.name
        };
      })
    : [];
};

export const getEquipmentDisplayName = equipment => {
  const id = equipment.id ?? '';
  const brand = equipment.brand ?? '';
  const model = equipment.model ?? '';

  return `${id} - ${brand} ${model}`;
};

export const insuranceDetailTabsIndex = {
  GENERAL: 'general',
  EQUIPMENTS: 'equipments'
};
